import { PlaceDetails } from '../../lib/types/models/place/place-detail'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getPlaceDetails(placeId: string) {
  return restApiClient
    .url(constructApiUrl(API.places.getPlaceDetails.url, { placeId: encodeURIComponent(placeId) }))
    .get<PlaceDetails>()
}
